import React, { useEffect, useState } from "react";

import axios from "../../axios-instance.js";

import "./OpenSell.sass";
import { getCurrentLanguageTexts } from "../../constants/seasonPassPersonalInfoLangs.js";
import CheckBox from "../../components/UI/Checkbox/CheckBox.js";
import { getSeatSideLabel, NfcToTicket, ticketTypes } from "../../helpers/ticketHelper.ts";
import closeIcon from "../../images/ic_x_2.svg";
import { getCouponDiscount } from "../../helpers/ticketPriceHelper.ts";

const renderOneTicket = (
  {
    ticket,
    currency,
    allowBuyNfc = false,
    isNfcChecked = false,
    handleNfcChange = null,
  },
  i,
  removeTicket,
) => {
  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">

      <div className="partizan-open-selling__selected-tickets-item-labels">

        <span className="partizan-open-selling__text-normal partizan-open-selling__selected-tickets-seat">
          {ticket.type === ticketTypes.MAP
            && <>{ticket.ticketName} {ticket.area}, {getSeatSideLabel(ticket.side)} Row {ticket.row} Seat {ticket.seat}</>
            || ticket.type === ticketTypes.MAP_NO_SEAT
            && <>{ticket.ticketName}</>
            || ticket.type === ticketTypes.NO_SEAT
            && <>{ticket.ticketName}</>
            || ticket.type === ticketTypes.SAVED
            && <>{ticket.ticketName}{ticket.seat ? `, ${ticket.area}, ${getSeatSideLabel(ticket.side)} Row ${ticket.row} Seat ${ticket.seat}` : ''} </>
            || ticket.type === ticketTypes.NFC
            && <>{ticket.ticketName}, {ticket.area} {getSeatSideLabel(ticket.side)}, Row {ticket.row} Seat {ticket.seat}</>}
        </span>

        <span className="partizan-open-selling__text-bold price">
          {ticket.getPrice()} {currency}
        </span>

        {removeTicket &&
          <img
            src={closeIcon}
            className="partizan-open-selling__selected-tickets-close"
            alt="close"
            onClick={removeTicket}
          />
        }

      </div>

      {allowBuyNfc &&
        <CheckBox
          name="buyNfcCard"
          id={`buy-nfc-card_${i}`}
          checked={isNfcChecked}
          onChange={(v) => {
            handleNfcChange(!isNfcChecked, `${ticket.area}-${ticket.side}-${ticket.row}-${ticket.seat}`)
          }}>
          Add NFC
        </CheckBox>}
    </div>
  );
};

const renderShortedTicket = (
  {
    tickets,
    currency
  },
  i,
) => {
  const ticket = tickets[0];
  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">

      <div className="partizan-open-selling__selected-tickets-item-labels">

        <span className="partizan-open-selling__text-normal partizan-open-selling__selected-tickets-seat">
          {ticket.ticketName} x {tickets.length}
        </span>

        <span className="partizan-open-selling__text-bold price">
          {tickets.reduce((a, t) => a + t.getPrice(), 0).toFixed(2)} {currency}
        </span>
      </div>
    </div>
  );
};

export const SelectedTickets = ({
  tickets = [],
  setCouponHandler,
  coupon,
  currency,
  total,
  administrativeFee = 0.0,
  processingFee = 0.0,
  paymentMethodSelected = false,
  hasSeats,
  mixedTickets,
  event,
  ticketAdd,
  ticketRemove,
  allowEnterCouponCode = true,
  autoHeight = false,
  pointsForDiscount = 0,
  allowManualDiscount = false,
  manualDiscount = 0,
  setManualDiscount = () => null,
  popupMode = false,
  theme = null,
  isTermsChecked,
  handleChangeCheckbox,
  showTermsAndConditionsModal,
  isTermsCheckbox = true,
  isOfferPage = false,
  onObjectDeselected,
  isMapLoading = false,
  allowSelectNfc = false,
  showShorted = false,
}) => {
  const txt = getCurrentLanguageTexts();

  const [couponCode, setCouponCode] = useState(coupon ? coupon.barcode : "");
  const [couponData, setCouponData] = useState(coupon);
  const [focusedElement, setFocusedElement] = useState(null);

  useEffect(() => {
    setCouponData(coupon);
    setCouponCode(coupon ? coupon.barcode : "");
  }, [coupon]);

  const couponDiscount = getCouponDiscount(tickets, coupon);

  const eventid = event ? event.eventId : 0;
  const isSeasonEvent = eventid == process.env.REACT_APP_NEW_SEASON_EVENT_ID;
  const nfcTicketTemplate = isSeasonEvent
    ? event.ticketTemplates.find(t => t.ticketTemplateId == process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID)
    : null;

  const handleCouponChanges = async (e) => {

    const code = e.target.value.toLowerCase();

    setCouponCode(code);

    try {
      var response = await axios.get(
        "/Transaction/couponDetails?couponCode=" +
        code +
        "&eventId=" +
        event.eventId,
        {}
      );

      if (response.data && response.data.isSuccess) {
        setCouponData(response.data.result);
        setCouponHandler(response.data.result);
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  if (hasSeats && isMapLoading) {
    return null
  }

  if (!tickets.length) {
    return (
      <div className="partizan-open-selling__empty-tickets">
        <img src="/images/img-empty-events.svg" alt="Select Ticket" />
        <p>
          {hasSeats
            ? txt.sellPageTxt["Select a ticket on the map"]
            : txt.sellPageTxt["Add a ticket from the list"]}
        </p>
      </div>
    );
  }

  const renderTickets = () => {

    if (showShorted) {

      const groupedTickets = tickets.reduce((a, t) => {
        const index = a.findIndex(i => i.ticketTemplateId == t.ticketTemplateId)

        if (index >= 0) {
          a[index].tickets.push(t);
        }
        else {
          a.push({
            ticketTemplateId: t.ticketTemplateId,
            tickets: [t]
          });
        }

        return a;
      }, []);
      return groupedTickets.map((t, i) => renderShortedTicket(t, i));
    }

    return tickets.map((ticket, i) => {
      const removeTicket = (!!onObjectDeselected && ticket.ticketTemplateId != process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID) ? () => {
        onObjectDeselected(ticket, true);
      }
        : null;



      return renderOneTicket({
        ticket,
        currency,
        allowBuyNfc: isSeasonEvent && allowSelectNfc && ticket.ticketTemplateId != process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID,
        isNfcChecked: ticket.isNfcChecked,
        handleNfcChange: (v, label) => {
          ticket.isNfcChecked = v;

          if (v) {
            ticket.nfc = NfcToTicket(ticket, nfcTicketTemplate);

            ticket.nfc.name = ticket.nfc.name + ` ${ticket.id}`;

            ticket.nfc.masterTicket = ticket;
            ticket.nfc.id = Math.random();

            if (ticketAdd) ticketAdd(ticket.nfc);
          }
          else if (ticket.nfc && ticketRemove) {
            ticketRemove(ticket.nfc);
          }
        }
      }, i, removeTicket)

    })
  };

  const totalTickets = () => {
    const total = tickets.reduce((a, t) => {
      return a + (t.count
        || 1);
    }, 0);

    return total;
  };

  const handleMouseEnter = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = theme.primarySemiLightColor;
    }
  };
  const handleMouseLeave = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = '#f1f1f1';
    }
  };
  const handleFocusElement = (e) => {
    if (theme) {
      e.target.style.borderColor = theme.primaryColor;
      setFocusedElement(e.target.name);
    }
  }
  const handleBlureElement = (e) => {
    if (theme) {
      e.target.style.borderColor = '#f1f1f1';
    }
    setFocusedElement(null);
  };

  const toggleCheckbox = () => {
    handleChangeCheckbox("termsAndConditionsChecked");
  }

  return (
    <>
      <div style={{ height: autoHeight ? 'auto' : '' }} className="partizan-open-selling__selected-tickets">
        <h4 className="partizan-open-selling__text-bold">{txt.SelectTicketTxt['tickets']} x {totalTickets()}</h4>
        {renderTickets()}
      </div>

      <div className="partizan-open-selling__total">
        {administrativeFee !== 0 && (
          <div style={{ opacity: '0.4', fontSize: '14px', fontWeight: 700 }}>
            <span>
              {txt.SelectTicketTxt['bookingFee']}:
            </span>
            <span>
              {administrativeFee.toFixed(2)} {currency}
            </span>
          </div>
        )}

        {processingFee !== 0 && (
          <div style={{ opacity: '0.4', fontSize: '14px', fontWeight: 700 }}>
            <span>
              {txt.SelectTicketTxt['processingFee']}*

            </span>
            <span>
              {processingFee.toFixed(2)} {currency}
            </span>
          </div>
        )}

        {pointsForDiscount
          ? <div>
            <span className="partizan-open-selling__text-bold-large">{txt.SelectTicketTxt['usedPoints']}:</span>
            <span className="partizan-open-selling__text-bold-large">
              -{pointsForDiscount} {currency}
            </span>
          </div>
          : ''
        }

        {couponDiscount
          ? <div>
            <span className="partizan-open-selling__text-bold-large">{txt.SelectTicketTxt['couponDiscount']}:</span>
            <span className="partizan-open-selling__text-bold-large">
              -{couponDiscount.toFixed(2)} {currency}
            </span>
          </div>
          : ''
        }

        <div>
          <span className="partizan-open-selling__text-bold-large">{txt.SelectTicketTxt['total']}:</span>
          <span className="partizan-open-selling__text-bold-large">
            {total.toFixed(2)} {currency}
          </span>
        </div>
        <div className="partizan-open-selling__vat">{txt.SelectTicketTxt['includedVAT']}</div>

        {processingFee !== 0 && (
          <div style={{ opacity: '0.4', fontSize: '12px' }}>
            *depends on payment type
          </div>
        )}
      </div>
      {allowEnterCouponCode && (
        <div className="partizan-open-selling__input_block">
          <label>{txt.sellPageTxt["Coupon code"]}</label>
          <input
            className="seasonpass__field-input"
            placeholder={txt.sellPageTxt["Enter coupon code"]}
            name="couponCode"
            onChange={(e) => handleCouponChanges(e)}
            onMouseEnter={handleMouseEnter}
            onFocus={handleFocusElement}
            onMouseLeave={handleMouseLeave}
            onBlur={handleBlureElement}
            type="text"
            value={couponCode}
            disabled={couponData}
          />
        </div>
      )}

      {allowManualDiscount && (
        <div className="partizan-open-selling__input_block">
          <label>Manual discount</label>
          <input
            className="seasonpass__field-input"
            placeholder="Enter fixed discount"
            name="manualDiscount"
            onChange={(e) => setManualDiscount(e.target.value)}
            onMouseEnter={handleMouseEnter}
            onFocus={handleFocusElement}
            onMouseLeave={handleMouseLeave}
            onBlur={handleBlureElement}
            type="number"
            value={manualDiscount ? Number(manualDiscount).toString() : ''}
          />
        </div>
      )}

      {isTermsCheckbox && (
        <CheckBox
          checked={isTermsChecked}
          id="terms-and-conditions-checkbox"
          name="terms-and-conditions-checkbox"
        >
          <span
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '120px',
              height: '30px',
              zIndex: "20"
            }}
            onClick={() => toggleCheckbox()}
          ></span>
          <span
            className="partizan-open-selling__text-medium-small"

          >
            {txt.sellPageTxt["I agree with"]}
            <span
              className="partizan-open-selling__terms-of-service-text"
              onClick={showTermsAndConditionsModal}
              style={{
                color: theme ? theme.secondaryColor : '',
              }}
            >
              {txt.sellPageTxt["Terms of Service"]}
            </span>
          </span>
        </CheckBox>
      )}
    </>
  );
};
